import { create } from "zustand";
import { useVendorMasterStore } from "../useVendorMasterStore";
import { CommercialTermsApi } from "../../services/vendorMaster";
const GUID = localStorage.getItem("vendorGUID");
const locationCode = localStorage.getItem("locationCode");
const VendorType = localStorage.getItem("VendorType") === "Trade";

const initial = {
  vendorGUID: GUID || "",
  locationCode: locationCode || "",
  businessType: null,
  agreedCreditDays: "",
  leadTime: "",
  inDaysSOR: "",
  discountPercent: 0,
  noOfDaysEarlier: 0,
  inFavourOf: "",
  bankName: "",
  branchName: "",
  accountNo: "",
  ifscCode: "",
  paymentMethod: "",
  anyMunicipalTax: null,
  replenishmentApprovalIndicator: null,
  returnAllowIndicator: null,
  accountReconciliationPeriod: null,
  freightTerms: null,
  taxPayerType: null,
  dsdIndicator: null,
};

const mapApiToCommercialTerms = (api) => ({
  vendorGUID: api?.VendorGUID ?? GUID,
  locationCode: api?.LocationCode ?? locationCode,
  businessType: api?.BusinessType ?? null,
  agreedCreditDays: api?.AgreedCreditDays ?? "",
  leadTime: api?.LeadTime ?? "",
  inDaysSOR: api?.InDaysSOR ?? "",
  discountPercent: api?.DiscountPercent ?? 0,
  noOfDaysEarlier: api?.NoOfDaysEarlier ?? 0,
  inFavourOf: api?.InFavourOf ?? "",
  bankName: api?.BankName ?? "",
  branchName: api?.BranchName ?? "",
  accountNo: api?.AccountNo ?? "",
  ifscCode: api?.IFSCCode ?? "",
  paymentMethod: api?.PaymentMethod ?? "",
  anyMunicipalTax: api?.AnyMunicipalTax ?? null,
  replenishmentApprovalIndicator: api?.ReplenishmentApprovalIndicator ?? null,
  returnAllowIndicator: api?.ReturnAllowIndicator ?? null,
  accountReconciliationPeriod: api?.AccountReconciliationPeriod ?? null,
  freightTerms: api?.FreightTerms ?? null,
  taxPayerType: api?.TaxPayerType ?? null,
  dsdIndicator: api?.DSDIndicator ?? null,
});

export const useCommercialStore = create((set, get) => ({
  commercialForm: {
    ...initial,
  },
  errors: null,

  setCommercialApi: (api) =>
    set(() => ({
      commercialForm: mapApiToCommercialTerms(api),
    })),

  handleInputChange: (field, value) =>
    set((state) => {
      let finalValue = value;

      // If checkbox → boolean
      if (typeof value === "boolean") {
        finalValue = value;
      }

      // Uppercase all strings except vendorGUID
      else if (typeof value === "string") {
        if (field !== "vendorGUID") {
          finalValue = value.toUpperCase();
        }
      }

      return {
        commercialForm: {
          ...state.commercialForm,
          [field]: finalValue,
        },
        errors: { ...state.errors, [field]: "" },
      };
    }),

  validateForm: () => {
    const { commercialForm } = get();
    const newErrors = {};
    const { vendorDetailByGuid } = useVendorMasterStore.getState();
    const { VendorType } = vendorDetailByGuid?.Vendor || {};
    const IFSC_REGEX = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    // Required fields
    if (!commercialForm.vendorGUID)
      newErrors.vendorGUID = "Vendor GUID is required";
    // if (!basicData.locationCode) newErrors.locationCode = "Location Code is required";
    if (!commercialForm.locationCode)
      newErrors.locationCode = "Location code is required";

    if (!commercialForm.businessType && VendorType !== "ZAEX")
      newErrors.businessType = "Buisness Type is required";
    if (!commercialForm.agreedCreditDays)
      newErrors.agreedCreditDays = "Agreed Credit Days is required";
    if (!commercialForm.leadTime && VendorType !== "ZAEX")
      newErrors.leadTime = "Lead time is required";
    if (!commercialForm.inFavourOf)
      newErrors.inFavourOf = "In favour of is required";
    if (!commercialForm.bankName) newErrors.bankName = "Bank Name is required";
    if (!commercialForm.branchName)
      newErrors.branchName = "Branch name is required";

    if (!commercialForm.accountNo)
      newErrors.accountNo = "Account number is required";

    if (!commercialForm.ifscCode) newErrors.ifscCode = "IFSC code is required";
    if (!commercialForm.ifscCode) {
      newErrors.ifscCode = "IFSC code is required";
    } else if (!IFSC_REGEX.test(commercialForm.ifscCode)) {
      newErrors.ifscCode = "Invalid IFSC code (e.g. SBIN0001234)";
    }

    if (!commercialForm.paymentMethod)
      newErrors.paymentMethod = "Payment method is required";
    if (commercialForm.returnAllowIndicator === null)
      newErrors.returnAllowIndicator = "Return allowed is required";

    // Save & return result
    set({ errors: newErrors });
    return Object.keys(newErrors).length === 0;
  },

  submitCommercialTerms: async (form) => {
    const { commercialForm } = get();
    set({ loading: true });
    try {
      const response = await CommercialTermsApi(commercialForm);
      return response?.Data[0];
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },

  // Reset form
  resetForm: () =>
    set({
      commercialForm: { ...initial },
      errors: null,
    }),
}));
